import Header from '../Components/Header/Header'
import Footer from '../Components/Footer/Footer'
import '../css/style.css'
import '../Pages/PrivacyPolicy.css'
import '../css/reset.css'
import '../css/responsive.css'
import '../css/glightbox.css'
import { useTranslation } from 'react-i18next'
import { sendDeleteAccountOtp, verifyOtpAndDeleteUser } from '../services/authService';
import React, { useState } from 'react'

function PrivacyPolicy() {
   const { t } = useTranslation();
   // states
   const [showModal, setShowModal] = useState(false);
   const [phone, setPhone] = useState('');
   const [otp, setOtp] = useState(['', '', '', '']);
   const [step, setStep] = useState(1);
   const [alert, setAlert] = useState(null); // { type: 'success' | 'error', message: '' }
   const [loading, setLoading] = useState(false);
   const [countryCode, setCountryCode] = useState("+966");

   const openModal = () => {
      setShowModal(true);
      setStep(1);
      setPhone('');
      setOtp(['', '', '', '']);
      setAlert(null);
   };

   const closeModal = () => {
      setShowModal(false);
      setStep(1);
      setPhone('');
      setOtp(['', '', '', '']);
      setAlert(null);
   };

   // send otp
   const handleSendOtp = async () => {
      if (!phone) return;

      setLoading(true);

      try {
         const res = await sendDeleteAccountOtp({ PhoneNumber: phone });
         setStep(2);
      } catch (error) {
         if (error.response?.status === 404) {
            setAlert({
               type: 'error',
               message: t('privacy.phoneNotFound')
            });
         } else {
            setAlert({
               type: 'error',
               message: t('privacy.somethingWrong')
            });
         }
      }

      setLoading(false);
   };


   // verify otp & delete
   const handleVerifyOtp = async () => {
      const finalOtp = otp.join('');
      if (finalOtp.length !== 4) return;

      setLoading(true);
      const res = await verifyOtpAndDeleteUser({
         PhoneNumber: phone,
         Otp: finalOtp,
      });
      setLoading(false);

      if (res?.error) {
         setAlert({ type: 'error', message: res.error });
      } else {
         setAlert({
            type: 'success',
            message: t('privacy.deleteSuccess')
         });
      }
   };
   const handleOtpChange = (value, index) => {
      if (!/^[0-9]?$/.test(value)) return;

      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (value && index < 3) {
         document.getElementById(`otp-${index + 1}`).focus();
      }
   };

   return (
      <>
         <Header />
         <section class="banners" style={{ backgroundImage: `url(${'../../images/banners_bg.webp'})` }} id='privacy-policy'>
            <div class="container">
               <div class="banner_head">
                  <h1>{t("privacy.Title1")}</h1>
                  {/* <p>An enim nullam tempor sapien gravida donec enim ipsum <br/> porta justo  congue purus pretium ligula </p> */}
               </div>
               <div class="bredcrub">
                  <a href="index.html" target="_self"> {t("header.home")} </a><span> <img src="images/arrow.png" alt="arrow" /></span>
                  <p>{t("privacy.Title1")}</p>
               </div>
            </div>
         </section>
         {/* <!--------------------|| Banner End ||------------------------> */}
         {/* <!----------------|| Terms of Use Css Start ||--------------------> */}
         <section class="term_condition">
            <div class="container">
               <div class="condition_contents">
                  <div class="term_heading">
                     <h2>{t("privacy.Title1")}</h2>
                     <p>{t("privacy.Discription1")}</p>
                  </div>
                  <div class="term_heading">
                     <h2>{t("privacy.Title2")}</h2>
                     <p>{t("privacy.Discription2")}</p>
                  </div>
                  <div class="term_heading">
                     <h2>{t("privacy.Title3")}</h2>
                     <p>{t("privacy.Discription3")}</p>
                  </div>
                  <div class="term_heading">
                     <h2>{t("privacy.Title4")}</h2>
                     <p>{t("privacy.Discription4")}</p>
                  </div>
                  <div class="term_heading">
                     <h2>{t("privacy.Title5")}</h2>
                     <p>{t("privacy.Discription5")}</p>
                  </div>
                  <div class="term_heading">
                     <h2>{t("privacy.Title6")}</h2>
                     <p>{t("privacy.Discription6")}</p>
                  </div>
                  <div class="term_heading">
                     <h2>{t("privacy.Title7")}</h2>
                     <p>{t("privacy.Discription7")}</p>
                  </div>
                  <div class="term_heading">
                     <h2>{t("privacy.Title8")}</h2>
                     <p>{t("privacy.Discription8")}</p>
                  </div>
                  <div class="term_heading">
                     <h2>{t("privacy.Title9")}</h2>
                     <p>{t("privacy.Discription9")}</p>
                  </div>
                  <div class="term_heading">
                     <h2>{t("privacy.Title10")}</h2>
                     <p>{t("privacy.Discription10")}</p>
                  </div>
                  <div class="term_heading">
                     <h2>{t("privacy.Title11")}</h2>
                     <p>
                        {t("privacy.Discription11")}
                        <a href="/delete-account" className="delete-link">
                           {t("privacy.DeleteLink")}
                        </a>
                     </p>
                  </div>


               </div>

            </div>
         </section>
         {showModal && (
            <div className="delete-modal-overlay">
               <div className="delete-modal">

                  {alert && (
                     <div className={`alert ${alert.type}`}>
                        {alert.message}
                        <span onClick={closeModal}>×</span>
                     </div>
                  )}

                  {step === 1 && (
                     <>
                        <h3 className="box_heading">{t('privacy.enterPhone')}</h3>

                        <div className="form_group">
                           <div className="phone_box">
                              <select
                                 name="country_code"
                                 value={countryCode}
                                 onChange={(e) => setCountryCode(e.target.value)}
                                 className="d-block"
                              >
                                 <option value="+966">+966</option>
                                 <option value="+1">+1</option>
                                 <option value="+20">+20</option>
                              </select>

                              <input
                                 type="text"
                                 name="PhoneNumber"
                                 value={phone}
                                 onChange={(e) => {
                                    const onlyNumbers = e.target.value.replace(/\D/g, '');
                                    setPhone(onlyNumbers);
                                 }}
                                 maxLength="9"
                                 placeholder={t('privacy.phonePlaceholder')}
                                 className="d-block"
                              />
                           </div>
                        </div>

                        <button
                           onClick={handleSendOtp}
                           disabled={loading}
                           className="login_button"
                        >
                           {loading ? t('privacy.loading') : t('privacy.next')}
                        </button>
                     </>
                  )}



                  {step === 2 && (
                     <>
                        <h3>{t('privacy.enterOtp')}</h3>

                        <div className="otp-container">
                           {otp.map((digit, index) => (
                              <input
                                 key={index}
                                 id={`otp-${index}`}
                                 type="text"
                                 maxLength="1"
                                 value={digit}
                                 onChange={(e) =>
                                    handleOtpChange(e.target.value, index)
                                 }
                                 className="otp-input"
                              />
                           ))}
                        </div>

                        <button onClick={handleVerifyOtp} disabled={loading}>
                           {loading ? t('privacy.loading') : t('privacy.confirm')}
                        </button>
                     </>
                  )}
               </div>
            </div>
         )}

         <Footer />
      </>
   )
}

export default PrivacyPolicy